import React from 'react';

const TriangleDown = () => {
  let acquirerCode=JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode;
  return (
    <svg className="triangle-down" width="8px" height="5px" viewBox="0 0 8 5" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Triangle Down</title>
      <defs />
      <g id="Transaction-Finder" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Transaction-Finder---Expanded" transform="translate(-854.000000, -418.000000)" fill={acquirerCode==='HPY' ? '#1362e2': "#FFFFFF"}>
          <g id="Filter-Drawer-(transaction-finder)" transform="translate(232.000000, 151.000000)">
            <g id="More-Button" transform="translate(24.000000, 257.000000)">
              <polygon id="Triangle-3" transform="translate(602.000000, 12.500000) scale(1, -1) translate(-602.000000, -12.500000) " points="602 10 606 15 598 15" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default TriangleDown;
